import React from "react";

const Cancel = ({fill, ...props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_7522_4626"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={32}
      height={32}
    >
      <rect width={32} height={32} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_7522_4626)">
      <path
        d="M11.1998 22.6667L15.9998 17.8667L20.7998 22.6667L22.6665 20.8L17.8665 16L22.6665 11.2L20.7998 9.33333L15.9998 14.1333L11.1998 9.33333L9.33317 11.2L14.1332 16L9.33317 20.8L11.1998 22.6667ZM15.9998 29.3333C14.1554 29.3333 12.4221 28.9833 10.7998 28.2833C9.17761 27.5833 7.7665 26.6333 6.5665 25.4333C5.3665 24.2333 4.4165 22.8222 3.7165 21.2C3.0165 19.5778 2.6665 17.8444 2.6665 16C2.6665 14.1556 3.0165 12.4222 3.7165 10.8C4.4165 9.17778 5.3665 7.76667 6.5665 6.56667C7.7665 5.36667 9.17761 4.41667 10.7998 3.71667C12.4221 3.01667 14.1554 2.66667 15.9998 2.66667C17.8443 2.66667 19.5776 3.01667 21.1998 3.71667C22.8221 4.41667 24.2332 5.36667 25.4332 6.56667C26.6332 7.76667 27.5832 9.17778 28.2832 10.8C28.9832 12.4222 29.3332 14.1556 29.3332 16C29.3332 17.8444 28.9832 19.5778 28.2832 21.2C27.5832 22.8222 26.6332 24.2333 25.4332 25.4333C24.2332 26.6333 22.8221 27.5833 21.1998 28.2833C19.5776 28.9833 17.8443 29.3333 15.9998 29.3333Z"
        fill={fill}
      />
    </g>
  </svg>
);

export default Cancel;
